import React, { createContext, useState, useEffect } from 'react';
import { getCurrentUser, login, logoutUser, registerUser, resetPassword, setAuthToken } from '../services/authService';
import { jwtDecode } from 'jwt-decode';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUser = async () => {
            const currentUser = getCurrentUser();
            if (currentUser) {
                setAuthToken(localStorage.getItem('token')); // Ensure setAuthToken is imported
                setUser(currentUser);
            }
            setLoading(false);
        };
        fetchUser();
    }, []);

    const loginUser = async (email, password) => {
        console.log('Login attempt with email:', email);
        console.log('Payload being sent to login function:', { email, password }); // Debugging log
        try {
            const response = await login({ email, password }); // Pass email and password directly
            console.log('Login response from authService:', response); // Debugging log
            setAuthToken(response.token); // Set the token in Axios headers
    
            // Decode the token to extract user details
            const decodedToken = jwtDecode(response.token);
            const user = { id: decodedToken.id, email: decodedToken.email };
            console.log('Decoded user from token:', user); // Debugging log
    
            setUser(user); // Update the user state
            return response; // Return the response to the caller
        } catch (error) {
            console.error('Login failed in AuthContext:', error);
            throw error;
        }
    };

    const register = async (name, email, password, phone) => {
        const newUser = await registerUser({ name, email, password, phone });
        setUser(newUser);
    };

    const logout = async () => {
        logoutUser();
        setUser(null);
    };

    const resetPasswordRequest = async (email) => {
        await resetPassword(email);
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <AuthContext.Provider value={{ user, login: loginUser, register, logout, resetPasswordRequest }}>
            {children}
        </AuthContext.Provider>
    );
};